(() => {
  if (customElements.get('sticky-atc')) return;

  class StickyAtc extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.afterScroll = this.dataset.afterScroll === 'true';
      this.isScrollBtn = this.dataset.scrollBtn === 'true';
      this.scrollDestination = this.dataset.scrollDestination;

      // Parse variants JSON from the picker inside this sticky bar.
      this.variants = this.parseVariants();

      if (this.afterScroll) {
        this.style.transform = 'translateY(110%)';
        this.initScrollObserver();
      }

      if (this.isScrollBtn) {
        this.initScrollButton();
      } else {
        this.initAtcButton();
      }
    }

    parseVariants() {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
    }

    /* ---- Show / Hide ---- */

    initScrollObserver() {
      const mainAtcBtn = document.querySelector(
        `#ProductSubmitButton-${this.sectionId}, #product-form-${this.sectionId} [type="submit"]`
      );
      if (!mainAtcBtn) { this.show(); return; }

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) this.hide();
          else this.show();
        },
        { threshold: 0 }
      );
      observer.observe(mainAtcBtn);
    }

    show() { this.style.transform = 'translateY(0)'; }
    hide() { this.style.transform = 'translateY(110%)'; }

    /* ---- Resolve variant id directly from the sticky picker selects ---- */

    getVariantId() {
      // 1. Combined picker: single select with class .sticky-atc__variant-select
      const combinedSelect = this.querySelector('.sticky-atc__variant-select');
      if (combinedSelect && this.variants) {
        const opt = combinedSelect.options[combinedSelect.selectedIndex];
        if (opt) {
          const raw = opt.dataset.options || combinedSelect.value || '';
          const selectedOpts = raw.split(',').map(s => s.trim());
          const variant = this.variants.find(v =>
            selectedOpts.every((val, i) => v.options[i] === val)
          );
          if (variant) return variant.id;
        }
      }

      // 2. Separate picker: multiple selects with name="options[...]"
      const separateSelects = this.querySelectorAll('select[name^="options["]');
      if (separateSelects.length && this.variants) {
        const selectedOpts = Array.from(separateSelects).map(s => s.value);
        const variant = this.variants.find(v =>
          selectedOpts.every((val, i) => v.options[i] === val)
        );
        if (variant) return variant.id;
      }

      // 3. No picker in sticky bar — read from the main product form.
      const mainForm = document.getElementById(`product-form-${this.sectionId}`);
      if (mainForm) {
        const idInput = mainForm.querySelector('input[name="id"]');
        if (idInput && idInput.value) return parseInt(idInput.value, 10);
      }

      return null;
    }

    /* ---- ATC button ---- */

    initAtcButton() {
      const btn = this.querySelector('.main-product-atc');
      if (!btn) return;

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (btn.disabled) return;
     let hasOnlyDefaultVariant = btn.getAttribute("data-variants-length");
        if (hasOnlyDefaultVariant!=""){
                 const variantId = this.getVariantId();
        if (!variantId) return;

        btn.setAttribute('disabled', '');

        const cartTarget =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        // Build request.
        let quantity = 1;
        const qtyInput = document.querySelector(
          `#Quantity-${this.sectionId}, product-info[data-section="${this.sectionId}"] .quantity__input`
        );
        if (qtyInput && parseInt(qtyInput.value, 10) > 0) {
          quantity = parseInt(qtyInput.value, 10);
        }

        const body = { items: [{ id: variantId, quantity }] };

        const preorder = document.querySelector(`pw-preorder[data-form-id="product-form-${this.sectionId}"]`);
        if (preorder && typeof preorder.update === 'function') preorder.update();
        const properties = {};
        document
          .querySelectorAll(`#product-form-${this.sectionId} input[type="hidden"][name^="properties["]`)
          .forEach((input) => {
            properties[input.name.slice(11, -1)] = input.value;
          });
        if (Object.keys(properties).length) body.items[0].properties = properties;

        if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
          body.sections = cartTarget.getSectionsToRender().map(s => s.section);
          body.sections_url = window.location.pathname;
          if (typeof cartTarget.setActiveElement === 'function') {
            cartTarget.setActiveElement(document.activeElement);
          }
        }

        try {
          const res = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          });
          const data = await res.json();

          if (data.status) {
            const errEl = btn.querySelector('.sticky-atc__error');
            if (errEl) {
              errEl.textContent = data.description || data.message || 'Error';
              errEl.style.display = '';
              setTimeout(() => { errEl.style.display = 'none'; }, 4000);
            }
            return;
          }

          if (cartTarget && typeof cartTarget.renderContents === 'function' && data.sections) {
            cartTarget.renderContents(data);
          }
          if (typeof updateCartCounters === 'function') updateCartCounters();
        } catch (err) {
          console.error('sticky-atc add failed', err);
        } finally {
          btn.removeAttribute('disabled');
        }
      }else{
  
          document.querySelector('.product__buy-buttons ')
        .scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      });
    }

    /* ---- Scroll button ---- */

    initScrollButton() {
      const btn = this.querySelector('.sticky-atc__scroll-btn');
      if (!btn) return;

      btn.addEventListener('click', () => {
        let selector = this.scrollDestination || '';
        selector = selector.replace(/-id$/, `-${this.sectionId}`);
        const target = document.querySelector(selector);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
  }

  customElements.define('sticky-atc', StickyAtc);
})();
